import { FC } from 'react';

import * as S from './styles';
import * as T from 'common/types';
import { ReactSVG } from 'react-svg';

const PanelBoxLayout: FC<T.Layout.PanelBox> = ({
  children,
  title,
  hint,
  className,
  icon,
  info,
  contentStyle,
  titleStyle,
  id,
  style,
  afterTitle,
  headStyle
}) => {
  return (
    <S.BoxContainer style={style} id={id} className={className}>
      {icon || title || hint || info ? (
        <S.Head style={headStyle}>
          <S.TitleCon>
            {icon && (
              <S.Icon className="flex-center">
                <ReactSVG
                  src={icon}
                  beforeInjection={(svg) => {
                    svg.setAttribute('stroke', 'currentColor');
                    svg.setAttribute('height', '16px');
                    svg.setAttribute('width', '16px');
                  }}
                />
              </S.Icon>
            )}
            {title && <S.Title style={titleStyle}>{title}</S.Title>}
            {hint && <S.Hint>{hint}</S.Hint>}
            {afterTitle && afterTitle}
          </S.TitleCon>
          {info ? <S.Div>{info}</S.Div> : <></>}
        </S.Head>
      ) : (
        <></>
      )}
      <S.Content style={contentStyle}>{children}</S.Content>
    </S.BoxContainer>
  );
};

export default PanelBoxLayout;
